// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"G1dd918","resetFormTitle":"G10ff71","resetPasswordButton":"G553021"};